import SCREEN_BREAKPOINTS from "../../const/breakpoints";

const hasMatchMedia = typeof window.matchMedia === "function";

const screenMaxWidth = breakpoint => (
  hasMatchMedia
  && window.matchMedia(`screen and (max-width: ${breakpoint}px)`).matches
);

const screenMinWidth = breakpoint => (
  hasMatchMedia
  && window.matchMedia(`screen and (min-width: ${breakpoint + 1}px)`).matches
);

const windowSize = {
  isSmallPalm: () => screenMaxWidth(SCREEN_BREAKPOINTS.smallPalm),

  isPalm: () => (
    screenMinWidth(SCREEN_BREAKPOINTS.smallPalm)
    && screenMaxWidth(SCREEN_BREAKPOINTS.mobile)
  ),

  isMobile: () => screenMaxWidth(SCREEN_BREAKPOINTS.mobile),

  isTab: () => (
    screenMinWidth(SCREEN_BREAKPOINTS.mobile)
    && screenMaxWidth(SCREEN_BREAKPOINTS.handheld)
  ),

  isHandheld: () => screenMaxWidth(SCREEN_BREAKPOINTS.handheld),

  isLap: () => (
    screenMinWidth(SCREEN_BREAKPOINTS.handheld)
    && screenMaxWidth(SCREEN_BREAKPOINTS.portable)
  ),

  isDesk: () => screenMinWidth(SCREEN_BREAKPOINTS.portable),

  isMaxWidth: width => screenMaxWidth(width)
};

export default windowSize;



// WEBPACK FOOTER //
// ./shared/helpers/window_size.js